const ru = {
  title: 'Подтверждение действия',
  listIsFull: 'Список Персон заполнен',
  savedPersonasTxt: 'Сохраненные Персоны',
  personaLimit:
    'Вы достигли лимита допустимых Персон. Вы можете удалить одну из персон на странице',
};

export default ru;
